import { ICurrentConfig } from "apollo/cache/config";
import { FC } from "react"
import { wrapImage } from "utils";

const PropertyInfoCard: FC<{ data: any; config: ICurrentConfig }> = ({ data, config: { dateFormat } }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div className=''>
      <span className="text-xs font-light">Location Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Region
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.region?.name || "N/A"}
          </div>
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            District
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.district?.name || "N/A"}
          </div>
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Ghana Post Address
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.ghanaPostAddress || "N/A"}
          </div>
        </div>
      </div>
    </div>
    <div className='pt-6'>
      <span className="text-xs font-light">Premise Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Premise Type
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.premiseType?.name || "N/A"}
          </div>
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Premise Category
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.premiseCategory?.name || "N/A"}
          </div>
        </div>
        <div className="relative">
          {
            data?.result === "Passed" &&
            <img
              alt="Passed"
              className="h-32 w-auto absolute -top-5 left-0"
              src={"/passed-stamp.png"}
            />
          }
          {
            data?.result === "Failed" &&
            <img
              alt="Failed"
              className="h-32 w-auto absolute -top-5 left-0"
              src={"/failed-stamp.png"}
            />
          }
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Activity
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.activity?.name || "N/A"}
          </div>
        </div>
        <div className="col-span-2">
          <span className="block text-sm font-light text-gray-700">
            Sub Activity
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.subActivity?.name || "N/A"}
          </div>
        </div>
        <div className="">
          <span className="block text-sm font-light text-gray-700">
            Closest Pole Number
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.closestPoleNumber || "N/A"}
          </div>
        </div>
        <div className="">
          <span className="block text-sm font-light text-gray-700">
            Nearby Geo Code
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.nearbyGeoCode || "N/A"}
          </div>
        </div>
        <div className="">
          <span className="block text-sm font-light text-gray-700">
            Proposed Geo Code
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.proposedGeoCode || "N/A"}
          </div>
        </div>
        <div className="">
          <span className="block text-sm font-light text-gray-700">
            Transformer Serial Number
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.transformerNumber || "N/A"}
          </div>
        </div>
        <div className="">
          <span className="block text-sm font-light text-gray-700">
            Meter Location
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.meterLocation || "N/A"}
          </div>
        </div>
      </div>
    </div>
    <div className='pt-6'>
      <span className="text-xs font-light">Premise Information</span>
      <div className='grid gap-6 mt-2'>
        <div className="">
          <span className="block text-sm font-light text-gray-700">
            Premise Images
          </span>
          <div className='mt-2 grid grid-cols-3 gap-3'>
            {data?.propertyImageUrls?.map((image: string) => wrapImage(
              <img
                src={image}
                alt={"back"}
                className="w-full h-56 text-xs object-cover object-center rounded"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default PropertyInfoCard